exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.highlighted[data-v-2107b802] {\n  color: #1f78d1;\n  font-weight: 600;\n}\n", ""]);

